import type { QueryClientConfig } from "@tanstack/react-query";

// import { retry } from "@api/errorHandler/reactQuery";
// TODO: @pouya
export const reactQueryConfig: QueryClientConfig = {
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: 1 },
  },
};
